import { render, staticRenderFns } from "./templateSelect.vue?vue&type=template&id=4508da54&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./templateSelect.vue?vue&type=style&index=0&id=4508da54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4508da54",
  null
  
)

export default component.exports